export const expandRoutes = (modules, path) => [].concat(...modules.map(m => m[path] || []))
